/* global axios */
import ApiClient from '../ApiClient';

class DeliveryUnknownsAPI extends ApiClient {
  constructor() {
    super('teletel/delivery-unknowns', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  refreshMessage(
    conversationId,
    messageId,
    accountId = this.accountIdFromRoute
  ) {
    // MessageFinder's combined range includes `after` and excludes `before`.
    // Read this one existing message through the current conversation policy.
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/conversations/${conversationId}/messages`,
      { params: { after: messageId, before: messageId + 1 } }
    );
  }

  confirmRetry(conversationId, messageId, confirmation) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/messages/${messageId}/retry`,
      confirmation
    );
  }

  retryKnownMessage(conversationId, messageId) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/messages/${messageId}/retry`
    );
  }
}

export default new DeliveryUnknownsAPI();
